module.exports = __webpack_public_path__ + "media/images/creator/home/icon-story-0261157f866da9c402c80f90fbe3bd95.svg";